import { useParams } from "react-router";
import { FormProvider } from "../../../providers/FormProvider";
import FormRootPage from "./FormRootPage";

export default function FormRoot() {
  const { linkId } = useParams();
  
  return (
    <FormProvider linkId={linkId}>
      <FormRootPage />
    </FormProvider>    
  );
}
